import { render, staticRenderFns } from "./CollapseItem.vue?vue&type=template&id=7aff1abc&"
import script from "./CollapseItem.vue?vue&type=script&lang=js&"
export * from "./CollapseItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7aff1abc')) {
      api.createRecord('7aff1abc', component.options)
    } else {
      api.reload('7aff1abc', component.options)
    }
    module.hot.accept("./CollapseItem.vue?vue&type=template&id=7aff1abc&", function () {
      api.rerender('7aff1abc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Collapse/CollapseItem.vue"
export default component.exports